import { render } from "./CustomerDiscountGroups.html?vue&type=template&id=6f425c49&scoped=true"
import script from "./CustomerDiscountGroups.js?vue&type=script&lang=js"
export * from "./CustomerDiscountGroups.js?vue&type=script&lang=js"

import "./CustomerDiscountGroups.css?vue&type=style&index=0&id=6f425c49&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f425c49"]])

export default __exports__